import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { DictData, DictionaryBase } from '@/common/staticDict/types';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcIdCard from '@/types/table/wkcIdCard';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcIdCardData extends WkcIdCard {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcIdCardController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcIdCardData>>(API_CONTEXT + '/app/wkcIdCard/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcIdCardData>(API_CONTEXT + '/app/wkcIdCard/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcIdCard/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcIdCard/import', params);
  }
  static printUrl(params: ANY_OBJECT) { 
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcIdCard/add', params, httpOptions);
  }
    static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcIdCard/saveDetaileAndUpdateReturnTime', params, httpOptions);
  }
  static saveDetaileAndUpdateReturnTime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcIdCard/saveDetaileAndUpdateReturnTime', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcIdCard/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcIdCard/deleteBatch', params, httpOptions);
  }

  static getUserList(params: ANY_OBJECT, httpOptions?: RequestOption) {
      return new Promise<DictionaryBase>((resolve, reject) => {
        super.get<DictData[]>(API_CONTEXT +'/app/wkcIdCard/getUserList', params, httpOptions)
          .then(res => {
            let dictData = new DictionaryBase('搜索指定用户', res.data);
            resolve(dictData);
          }).catch(err => {
            reject(err);
          });
      });
    }

static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
      return super.post<TableData<WkcIdCardData>>(API_CONTEXT + '/app/wkcPrivateExitRecords/getUserInformation', params, httpOptions);
}

//根据编码查询数据
static getWkcIdCardNumber(params: ANY_OBJECT, httpOptions?: RequestOption) {
  return super.get<WkcIdCardData>(API_CONTEXT + '/app/wkcIdCard/getWkcIdCardNumber', params, httpOptions);
}

}
